<script lang="ts" module>
  import type { SVGAttributes } from 'svelte/elements';

  import type { IconsBaseProps } from './gen/icons.types.ts';
  import * as IconComponents from './gen/index';

  export type IconName =
    | keyof typeof IconComponents
    | 'TodoIndicator'
    | 'Loading'
    | 'NWPLogo'
    | 'TCLLogo';

  export type IconProps = IconsBaseProps & { icon: IconName } & SVGAttributes<SVGSVGElement>;
  export const allIconNames = Object.keys(IconComponents) as (keyof typeof IconComponents)[];

  export const Icons = IconComponents;
</script>

<script lang="ts">
  import LoadingIcon from './specials/Loading.svelte';
  import NWPLogo from './specials/NWPLogo.svelte';
  import TCLLogo from './specials/TCLLogo.svelte';
  import TodoIndicator from './specials/TodoIndicator.svelte';

  let { icon, class: className, ...props }: IconProps = $props();

  let IconComponent = $derived(
    icon === 'TodoIndicator' ? TodoIndicator
    : icon === 'TCLLogo' ? TCLLogo
    : icon === 'NWPLogo' ? NWPLogo
    : icon === 'Loading' ? LoadingIcon
    : IconComponents[icon],
  );
</script>

<IconComponent {...props} class={className} />
